// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.welcome-modal_modal-content_bmsgr {
    max-width: 600px;
}

.welcome-modal_body_kOQ2c {
    background: var(--ui-modal-background);
    padding: 1.5rem 2.25rem;
    max-height: calc(80vh - 250px);
    overflow-y: auto;
}

.welcome-modal_body_kOQ2c input[type="checkbox"],
.welcome-modal_body_kOQ2c input[type="radio"] {
    margin: 3px;
}

.welcome-modal_text-input_dWdve {
    margin-bottom: 1rem;
    width: 100%;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 5px;
    padding: 0 1rem;
    height: 3rem;
    color: var(--ui-text-primary-transparent);
    font-size: .875rem;
    background-color: var(--input-background);
}

.welcome-modal_dont-show-container_b3DEf {
    display: flex;
    align-items: center;
}

.welcome-modal_dont-show-checkbox_vU1Nw {
    margin-right: 0.5rem;
}

.welcome-modal_button-row_hR2Yd {
    font-weight: bolder;
    text-align: right;
    background: var(--ui-modal-background);
    padding: 1.5rem 2.25rem;
}

.welcome-modal_button-row_hR2Yd button {
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    background: white;
    border: 1px solid var(--ui-black-transparent);
    font-weight: 600;
    font-size: 0.85rem;
}

[dir="ltr"] .welcome-modal_button-row_hR2Yd button + button {
    margin-left: 0.5rem;
}

[dir="rtl"] .welcome-modal_button-row_hR2Yd button + button {
    margin-right: 0.5rem;
}

.welcome-modal_button-row_hR2Yd button.welcome-modal_close-button_t93oB {
    background: var(--looks-secondary);
    border: var(--looks-secondary);
    color: white;
}

.welcome-modal_text_yklHX {
    margin-bottom: 1rem;
}

.welcome-modal_poster_Mj0h5 {
    width: 100%;
    border-radius: 0.5rem;
    margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/dash-welcome-modal/welcome-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,6CAA6C;IAC7C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,mBAAmB;AACvB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n    max-width: 600px;\n}\n\n.body {\n    background: var(--ui-modal-background);\n    padding: 1.5rem 2.25rem;\n    max-height: calc(80vh - 250px);\n    overflow-y: auto;\n}\n\n.body input[type=\"checkbox\"],\n.body input[type=\"radio\"] {\n    margin: 3px;\n}\n\n.text-input {\n    margin-bottom: 1rem;\n    width: 100%;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 5px;\n    padding: 0 1rem;\n    height: 3rem;\n    color: var(--ui-text-primary-transparent);\n    font-size: .875rem;\n    background-color: var(--input-background);\n}\n\n.dont-show-container {\n    display: flex;\n    align-items: center;\n}\n\n.dont-show-checkbox {\n    margin-right: 0.5rem;\n}\n\n.button-row {\n    font-weight: bolder;\n    text-align: right;\n    background: var(--ui-modal-background);\n    padding: 1.5rem 2.25rem;\n}\n\n.button-row button {\n    padding: 0.75rem 1rem;\n    border-radius: 0.25rem;\n    background: white;\n    border: 1px solid var(--ui-black-transparent);\n    font-weight: 600;\n    font-size: 0.85rem;\n}\n\n[dir=\"ltr\"] .button-row button + button {\n    margin-left: 0.5rem;\n}\n\n[dir=\"rtl\"] .button-row button + button {\n    margin-right: 0.5rem;\n}\n\n.button-row button.close-button {\n    background: var(--looks-secondary);\n    border: var(--looks-secondary);\n    color: white;\n}\n\n.text {\n    margin-bottom: 1rem;\n}\n\n.poster {\n    width: 100%;\n    border-radius: 0.5rem;\n    margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `welcome-modal_modal-content_bmsgr`;
export { _1 as "modal-content" };
export var modalContent = `welcome-modal_modal-content_bmsgr`;
export var body = `welcome-modal_body_kOQ2c`;
var _2 = `welcome-modal_text-input_dWdve`;
export { _2 as "text-input" };
export var textInput = `welcome-modal_text-input_dWdve`;
var _3 = `welcome-modal_dont-show-container_b3DEf`;
export { _3 as "dont-show-container" };
export var dontShowContainer = `welcome-modal_dont-show-container_b3DEf`;
var _4 = `welcome-modal_dont-show-checkbox_vU1Nw`;
export { _4 as "dont-show-checkbox" };
export var dontShowCheckbox = `welcome-modal_dont-show-checkbox_vU1Nw`;
var _5 = `welcome-modal_button-row_hR2Yd`;
export { _5 as "button-row" };
export var buttonRow = `welcome-modal_button-row_hR2Yd`;
var _6 = `welcome-modal_close-button_t93oB`;
export { _6 as "close-button" };
export var closeButton = `welcome-modal_close-button_t93oB`;
export var text = `welcome-modal_text_yklHX`;
export var poster = `welcome-modal_poster_Mj0h5`;
export default ___CSS_LOADER_EXPORT___;
